@if (erzeugungsanlagen) {
  <div class="container">
    <table
      mat-table [dataSource]="erzeugungsanlagen"
      class="erzeugungsanlagen-table"
      matSort
      (matSortChange)="_sortChange($event)"
      [matSortDirection]="sortDirection"
      [matSortActive]="sortActive"
      >
      <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
      <tr mat-row *matRowDef="let erzeugungsanlage; columns: columnsToDisplay"
      data-qa="list-erzeugungsanlage-tile"></tr>
      <ng-container matColumnDef="dokumentenId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Dokumenten-ID</th>
        <td mat-cell *matCellDef="let erzeugungsanlage;">{{ erzeugungsanlage.dokumentenId }}</td>
      </ng-container>
      <ng-container matColumnDef="resourceIds.steuerbareResourceId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>SR-ID</th>
        <td mat-cell
          *matCellDef="let erzeugungsanlage;">{{ erzeugungsanlage.resourceIds?.steuerbareResourceId }}
        </td>
      </ng-container>
      <ng-container matColumnDef="resourceIds.technischeResourceId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>TR-ID</th>
        <td mat-cell
          *matCellDef="let erzeugungsanlage;">{{ erzeugungsanlage.resourceIds?.technischeResourceId }}
        </td>
      </ng-container>
      <ng-container matColumnDef="bezVnbIntern">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Bezeichnung VNB intern</th>
        <td mat-cell *matCellDef="let erzeugungsanlage;">{{ erzeugungsanlage.bezVnbIntern }}</td>
      </ng-container>
      <ng-container matColumnDef="netzzuordnung.stationsname">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Netzzuordnung<br/>Stationsname</th>
        <td mat-cell *matCellDef="let erzeugungsanlage;">{{ erzeugungsanlage.netzzuordnung.stationsname }}</td>
      </ng-container>
      <ng-container matColumnDef="netzzuordnung.ortsname">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Netzzuordnung<br/>Ortsname</th>
        <td mat-cell *matCellDef="let erzeugungsanlage;">{{ erzeugungsanlage.netzzuordnung.ortsname }}</td>
      </ng-container>
      <ng-container matColumnDef="netzzuordnung.trafoFeldName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Netzzuordnung<br/>Trafo/Feldnr</th>
        <td mat-cell *matCellDef="let erzeugungsanlage;">{{ erzeugungsanlage.netzzuordnung.trafoFeldName }}</td>
      </ng-container>
      <ng-container matColumnDef="netzzuordnung.deactivated">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Netzzuordnung<br/>Status</th>
        <td mat-cell *matCellDef="let erzeugungsanlage;">
          @if (erzeugungsanlage.netzzuordnung.deactivated) {
            <mat-icon matTooltip="Die Netzzuordnung ist deaktiviert worden. Bitte wählen Sie eine gültige aus."
                      matTooltipPosition="right"
                      svgIcon="innogy_picto_speech-bubble_questionmark"
                      aria-hidden="false"
                      aria-label="Die Netzzuordnung ist deaktiviert worden. Bitte wählen Sie eine gültige aus."
                      class="warning-deactivated-netzzuordnung"
            >
            </mat-icon>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="energietraeger">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Energieträger</th>
        <td mat-cell *matCellDef="let energietraeger;">{{ energietraeger.energietraeger | energietraeger }}
        </td>
      </ng-container>
      <ng-container matColumnDef="leistung.bruttonennleistung">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Bruttonennleistung</th>
        <td mat-cell
          *matCellDef="let erzeugungsanlage;">{{ erzeugungsanlage.leistung?.bruttonennleistung | leistungseinheit }}
        </td>
      </ng-container>
      <ng-container matColumnDef="netzzuordnung.netzbetreiber.name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Netzbetreibername</th>
        <td mat-cell *matCellDef="let erzeugungsanlage;">{{ erzeugungsanlage.netzzuordnung.netzbetreiber.name }}
        </td>
      </ng-container>
      <ng-container matColumnDef="netzzuordnung.netzbetreiber.teilgebiet">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Teilgebiet</th>
        <td mat-cell
          *matCellDef="let erzeugungsanlage;">{{ erzeugungsanlage.netzzuordnung.netzbetreiber.teilgebiet }}
        </td>
      </ng-container>
      <ng-container matColumnDef="anlage" stickyEnd>
        <th mat-header-cell *matHeaderCellDef class="icon-column" style="text-align: center">Anlage</th>
        <td mat-cell *matCellDef="let erzeugungsanlage;" class="icon-column">
          <div fxLayoutAlign="center center">
            <button mat-icon-button
              [routerLink]="routingService.erzeugungsanlagePath()"
              [queryParams]="{erzeugungsanlage: erzeugungsanlage.dokumentenId}"
              [queryParamsHandling]="'merge'">
              <div [matTooltip]="erzeugungsanlage.invalidFieldValues ? 'Dieser Datensatz ist invalide' : ''"
                style="display: flex; align-items: center; justify-content: center;">
                <mat-icon [class.custom-icon-with-badge]="erzeugungsanlage.invalidFieldValues"
                          [matBadge]="erzeugungsanlage.invalidFieldValues ? '?' : ''"
                          matBadgeOverlap="false"
                          aria-hidden="false"
                          aria-label="Details der Erzeugungsanlage öffnen"
                          [svgIcon]="isWestnetz ? 'innogy_picto_eye' : 'innogy_picto_pen'"
                >
                </mat-icon>
              </div>
            </button>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="planwerte" stickyEnd>
        <th mat-header-cell *matHeaderCellDef class="icon-column" style="text-align: center">Planwerte</th>
        <td mat-cell *matCellDef="let erzeugungsanlage;" class="icon-column">
          <div fxLayoutAlign="center center">
            @if (!isWestnetz) {
              <button mat-icon-button
                [routerLink]="routingService.erzeugungsanlagePath()"
                [disabled]="erzeugungsanlage.invalidFieldValues > 0"
                [queryParamsHandling]="'merge'"
                [queryParams]="{erzeugungsanlage: erzeugungsanlage.dokumentenId, createnewplannedvalue: true}">
                <mat-icon>flag</mat-icon>
              </button>
            }
            <button mat-icon-button [disabled]="!erzeugungsanlage.hasPlanwert"
              [routerLink]="routingService.planwertPath()"
              [queryParams]="{erzeugungsanlageDokumentenId: erzeugungsanlage.dokumentenId}">
              <mat-icon svgIcon="innogy_picto_arrow-right"></mat-icon>
            </button>
          </div>
        </td>
      </ng-container>
    </table>
  </div>
}
